import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OpenStockApi } from '../api/openstock.api';
import { switchMap, map } from 'rxjs/operators';

import { OpenStockData, OpenStock} from '../../../interfaces/pharmacy/openstock' ;
@Injectable()
export class OpenStockService extends OpenStockData {

    constructor(private api: OpenStockApi) {
      super();
    }
  searchList(url: string,data:any): Observable<any> {     
      return this.api.searchList(url,data);
    }
  
    list(url: string): Observable<OpenStock[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<OpenStock>{
        return this.api.getById(url);
    }
  
    create(url: string, data:OpenStock): Observable<OpenStock[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:OpenStock): Observable<OpenStock> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  